import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from "react-responsive-carousel";


export default () => (
    <div className="carousel-banner">
        <Carousel 
            autoPlay
            showThumbs={false}
            showArrows={false}
            showStatus={false}
            showIndicators={false}
            useKeyboardArrows={false}
            stopOnHover={false}
            infiniteLoop={true}
            transitionTime={0}
            interval={800}
        >
            <div>The world's most useful <span style={{color: "#F7BCFF"}}>Tennis</span> app</div>
            <div>The world's most useful <span style={{color: "#FCA6A6"}}>Pickleball</span> app</div>
            <div>The world's most useful <span style={{color: "#FCFDBA"}}>Padel </span>app</div>
            <div>The world's most useful <span style={{color: "#BBFFC6"}}>Squash</span> app</div>
            <div>The world's most useful <span style={{color: "#6FEEFF"}}>Badminton</span> app</div>
            <div>The world's most useful <span style={{color: "#F7BCFF"}}>Racquetball</span> app</div>
            <div>The world's most useful <span style={{color: "#FCA6A6"}}>Paddle Ball</span> app</div>
            <div>The world's most useful <span style={{color: "#FCFDBA"}}>Court Tennis</span> app</div>
            <div>The world's most useful <span style={{color: "#BBFFC6"}}>Table Tennis</span> app</div>
            <div>The world's most useful <span style={{color: "#6FEEFF"}}>Platform tennis</span> app</div>
            <div>The world's most useful <span style={{color: "#FFDC97"}}>Paddle Tennis</span> app</div>
        </Carousel>
    </div>
  );

